export default __webpack_public_path__ + "static/media/picTriNguyen.2e03e68d.png";